import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";

const getMetricSuffix = (metricType: string, score: number | undefined) => {
  if (isNaN(score as number)) {
    return;
  }

  switch (metricType) {
    case MetricEventTypes.CRITICAL_SCAN:
      return "metric.critical_scan.short";
    case MetricEventTypes.SCAN_FREQUENCY:
      return "metric.scan_frequency.short";
    case MetricEventTypes.AWARENESS:
      return "metric.awareness.short";
    case MetricEventTypes.SCAN_TIMING:
      return "metric.scan_timing.short";
    case MetricEventTypes.DECISION:
      return "metric.decision.short";
    case MetricFilterTypes.GAMEPLAY_DURATION:
      if (score && score < 60) {
        return "metric.gameplay_duration.seconds.short";
      }

      return "metric.gameplay_duration.minutes.short";
    case MetricFilterTypes.BYB_IQ:
    default:
      return "";
  }
};

export default getMetricSuffix;
